import { Component, Vue, } from 'vue-property-decorator';
import ActionIcon from '@/components/action-icon/ActionIcon.vue';

@Component<ActionEditCancelIcon>({
  components: {
    'action-icon': ActionIcon,
  }
})
export default class ActionEditCancelIcon extends Vue { }
